import { RelativePosition } from '../../../hooks/useDragElement.js';
import { ToolbarPlacement } from '../../../types/toolbar.js';

/**
 * Gets toolbar top and right position with a given placement and a given boundaries
 *
 * @param placement -
 * @param maxBoundaries -
 */
export function getToolbarPlacement(
  placement: ToolbarPlacement,
  maxBoundaries: RelativePosition,
) {
  switch (placement) {
    case 'top-right': {
      return { top: 0, right: 0 };
    }
    case 'bottom-right': {
      return { top: maxBoundaries.top, right: 0 };
    }
    case 'bottom-left': {
      return { top: maxBoundaries.top, right: maxBoundaries.right, left: 0 };
    }
    case 'top-left': {
      return { top: 0, right: maxBoundaries.right, left: 0 };
    }
    default: {
      return { top: 0, right: 0 };
    }
  }
}
